import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@heroui/react';

interface UserAgentChipsProps {
  userAgent: string;
}

export function UserAgentChips({ userAgent }: UserAgentChipsProps) {
  const { t } = useTranslation();
  const parseUserAgent = (ua: string) => {
    const result = {
      browser: 'Unknown',
      os: 'Unknown',
      device: 'Desktop'
    };

    // Browser detection
    if (ua.includes('Chrome')) {
      result.browser = 'Chrome';
    } else if (ua.includes('Firefox')) {
      result.browser = 'Firefox';
    } else if (ua.includes('Safari') && !ua.includes('Chrome')) {
      result.browser = 'Safari';
    } else if (ua.includes('Edge')) {
      result.browser = 'Edge';
    }

    // OS detection
    if (ua.includes('Windows')) {
      result.os = 'Windows';
    } else if (ua.includes('Mac OS')) {
      result.os = 'macOS';
    } else if (ua.includes('Linux')) {
      result.os = 'Linux';
    } else if (ua.includes('Android')) {
      result.os = 'Android';
    } else if (ua.includes('iOS')) {
      result.os = 'iOS';
    }

    // Device detection
    if (ua.includes('Mobile')) {
      result.device = 'Mobile';
    } else if (ua.includes('Tablet')) {
      result.device = 'Tablet';
    } else if (ua.includes('HeadlessChrome')) {
      result.device = 'Bot';
    }

    return result;
  };

  const { browser, os, device } = parseUserAgent(userAgent);

  const getBrowserColor = (browser: string) => {
    switch (browser) {
      case 'Chrome':
        return 'primary';
      case 'Firefox':
        return 'warning';
      case 'Safari':
        return 'secondary';
      case 'Edge':
        return 'default';
      default:
        return 'default';
    }
  };

  const getOsColor = (os: string) => {
    switch (os) {
      case 'Windows':
        return 'success';
      case 'macOS':
        return 'default';
      case 'Linux':
        return 'primary';
      case 'Android':
        return 'success';
      case 'iOS':
        return 'secondary';
      default:
        return 'default';
    }
  };

  const getDeviceColor = (device: string) => {
    switch (device) {
      case 'Mobile':
        return 'primary';
      case 'Tablet':
        return 'secondary';
      case 'Bot':
        return 'danger';
      default:
        return 'default';
    }
  };

  return (
    <div className="flex flex-wrap gap-0.5">
      <Chip size="sm" color={getBrowserColor(browser)} variant="flat" className="text-xs">
        <small>{browser}</small>
      </Chip>
      <Chip size="sm" color={getOsColor(os)} variant="flat" className="text-xs">
        <small>{os}</small>
      </Chip>
      <Chip size="sm" color={getDeviceColor(device)} variant="flat" className="text-xs">
        <small>{device}</small>
      </Chip>
    </div>
  );
}
